module.exports = __webpack_public_path__ + "img/introduction.d9d857c0.png";